module.exports = __webpack_public_path__ + "img/money.35ff2977.svg";